
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/making-sense-of-legal-language",
      function () {
        return require("private-next-pages/resources/making-sense-of-legal-language.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/making-sense-of-legal-language"])
      });
    }
  